import HtmlNode from '../../Components/Extension/HtmlNode';
import { getVehicleErrorMessage } from '../../Http/getVehicle';
import { RequestError } from '../../Http/http';
import Alert from '../../Templates/Alert';

interface RequestStatusErrorProps {
  requestError?: RequestError;
}

class RequestStatusError extends HtmlNode {
  private readonly props: RequestStatusErrorProps;
  private requestError?: RequestError;

  constructor(element: HTMLElement | null, props: RequestStatusErrorProps) {
    super(element);
    this.props = props;
    this.requestError = props.requestError;

    this.render();
  }

  update(requestError?: RequestError) {
    this.requestError = requestError;
    this.render();
  }

  render() {
    if (!this.requestError) {
      this.node.innerHTML = '';
      return;
    }

    this.node.innerHTML = Alert({
      tone: 'error',
      children: getVehicleErrorMessage(this.requestError.status),
    });
  }
}

export default RequestStatusError;
